import { getBaseConfig } from './base.config';
export const config: any = getBaseConfig();
